
export function getMultiSelectState<T>(items: ReadonlyArray<T>, isSelected: (item: T) => boolean) {
  const selectedCount = items.filter(isSelected).length
  return items.length > 0 && selectedCount == items.length ? true
    : selectedCount > 0 ? undefined
    : false
}
